// extracted by mini-css-extract-plugin
export default {"connectedUsersIndicator":"ConnectedUsersIndicator_connectedUsersIndicator__odlUS","portraitWrapper":"ConnectedUsersIndicator_portraitWrapper__rGgS4"};